import { InputIcon } from "primereact/inputicon";
import { leasinInfoCSS } from "./LeasingInfo.css"
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { Button } from "primereact/button";
import { LeasingForm } from "./components/FormLeasing";
import { useEffect, useState } from "react";



export const LeasingInfo = ({ setPage, setPageStep3, setStep, pageStep3, state }) => {

    return (
        <div css={leasinInfoCSS()}>
            <section className="ButtonSection2">
                <div className="TopText">
                    El arrendamiento está a nombre de
                    <br />
                </div>
                <div className="TextContainer">
                    <span>Compártenos tus datos {pageStep3.selectedTypePerson === 2 ? 'y los de tu empresa' : ''}
                    </span>
                    <br />
                    <span>¿Cómo quieres continuar tu proceso?</span>
                    <span className="NormalMedium font-normal">Selecciona una opción</span>
                </div>

                <LeasingForm
                    setPage={setPage} setPageStep3={setPageStep3}
                    setStep={setStep} pageStep3={pageStep3}
                    state={state}
                />
            </section>
        </div>
    )
}